import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { usePackagePurchase } from "../model/usePackagePurchase";
import { registerSubscriptionResumeHandler } from "../model/subscriptionResume";
/**
 * Исполнитель «продолжить оформление подписки после входа». Монтируется один
 * раз в `App` и живёт всё время, поэтому не зависит от того, уцелела ли
 * карточка, по которой кликнул гость (см. `subscriptionResume`). Сам ничего не
 * рисует, кроме модалок оформления: согласие на автосписания и почта для чека.
 */
export const SubscriptionResumeHost = () => {
    const { resumeSubscriptionPurchase, billingEmailModal, subscriptionConsentModal } = usePackagePurchase();
    // Свежее замыкание хука — через ref: регистрируемся один раз.
    const resumeRef = useRef(resumeSubscriptionPurchase);
    resumeRef.current = resumeSubscriptionPurchase;
    useEffect(() => {
        registerSubscriptionResumeHandler((pkg, provider) => {
            void resumeRef.current(pkg, provider);
        });
        return () => registerSubscriptionResumeHandler(null);
    }, []);
    return (_jsxs(_Fragment, { children: [billingEmailModal, subscriptionConsentModal] }));
};
